import { DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFormGroupByTable extends Layout {
    sourceMCFormGroupBy: DataSource;
    tableFormGroupBy: Table;
    tableFormGroupByAll: Table;
    textboxGroupBy: Textbox;
}
